import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿En qué formato viene la guía?',
  answer: 'La guía viene en formato digital (PDF) de alta calidad, optimizado para que puedas leerlo cómodamente en tu celular, tablet o computadora, o imprimirlo si lo prefieres.'
}, {
  question: '¿Necesito experiencia previa?',
  answer: 'No, la guía está diseñada específicamente para principiantes. Cada receta incluye instrucciones detalladas paso a paso y explicamos los conceptos básicos desde cero.'
}, {
  question: '¿Dónde consigo los ingredientes?',
  answer: 'La mayoría de los ingredientes (como aceite de oliva, manzanilla o cera de abeja) se encuentran fácilmente en supermercados, tiendas naturistas, farmacias o tiendas en línea.'
}, {
  question: '¿Cuánto tiempo duran las pomadas?',
  answer: 'Al no contener agua, estas pomadas tienen una vida útil larga. Si se almacenan correctamente en un lugar fresco y oscuro, pueden durar entre 6 y 12 meses en perfectas condiciones.'
}, {
  question: '¿Puedo regalar la guía?',
  answer: '¡Sí! Es un excelente regalo para cualquier persona interesada en el cuidado natural de la piel o las manualidades. Una vez descargado el archivo, puedes enviarlo a esa persona especial.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <SectionWrapper id="faq" className="px-4 md:px-12 max-w-3xl mx-auto mb-20" data-id="element-36">
      <h2 className="text-3xl md:text-4xl font-playfair text-forest text-center mb-10" data-id="element-37">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-4" data-id="element-38">
        {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-sage/20 overflow-hidden shadow-sm" data-id="element-39">
            <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-40">
              <span className="font-playfair font-semibold text-lg text-forest pr-4" data-id="element-41">
                {faq.question}
              </span>
              <ChevronDown className={`w-5 h-5 text-sage transition-transform duration-300 shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-42" />
            </button>
            <AnimatePresence data-id="element-43">
              {openIndex === idx && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-44">
                  <div className="px-6 pb-5 text-brown/80 leading-relaxed" data-id="element-45">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </SectionWrapper>;
}